<template>
  <FeedFilterTag :on-click="handleClick">
    {{ $t(info.label) }}
  </FeedFilterTag>
</template>

<script setup>
import _ from 'lodash-es';
import { ROUTES } from "@utils/routes";
import FeedFilterTag from "@components/filter/feed/feed-filter-tag";

const props = defineProps({
  type: {
    type: String,
    required: true
  },
  data: {
    type: [Number, String],
    required: true
  }
});

const route = useRoute();

const routeName = computed(() => route?.name || '');

const info = computed(() => {
  if (routeName.value.startsWith('offers___') || routeName.value.startsWith('offers-slug___')) {
    return { label: 'text-my-offers', routeCode: ROUTES.CODE.OFFERS };
  } else if (routeName.value.startsWith('requests___') || routeName.value.startsWith('requests-slug___')) {
    return { label: 'text-my-requests', routeCode: ROUTES.CODE.REQUESTS };
  } else if (routeName.value.startsWith('auctions___') || routeName.value.startsWith('auctions-slug___')) {
    return { label: 'text-my-auctions', routeCode: ROUTES.CODE.AUCTIONS };
  } else if (routeName.value.startsWith('inspiration___') || routeName.value.startsWith('inspiration-type-slug___')) {
    return { label: 'text-my-inspiration', routeCode: ROUTES.CODE.INSPIRATION };
  } else if (routeName.value.startsWith('favorites___')) {
    return { label: 'text-my-favorites', routeCode: ROUTES.CODE.FAVORITES };
  } else if (routeName.value.startsWith('search___')) {
    return { label: 'text-my-favorites', routeCode: ROUTES.CODE.SEARCH };
  } else {
    return { label: 'text-my-ads', routeCode: ROUTES.CODE.ADS };
  }
});

const handleClick = async () => {
  await useSearchParam(props.type, '');
}

</script>
